export const CONFIGURATION_UPDATED = 'CONFIGURATION_UPDATED'
export const APPLICATION_SELECTED = 'APPLICATION_SELECTED'
